import React from "react";
import { CrudManager } from "@/components/cms/CrudManager";
import { ENTITIES } from "@/lib/entities";

export default function EntityPage({ configKey }: { configKey: string }) {
  const config = ENTITIES[configKey];
  if (!config) return <div>Configurazione non trovata.</div>;
  return <CrudManager key={configKey} config={config} />;
}
